module.exports = __webpack_public_path__ + "img/xls.d63d6b3c.png";